import { Service } from '@jcd-web/basic-service';
import { MailApi } from '../api/MailApi';
export class MailService extends Service {
    static contact(contact) {
        return MailApi.contact(contact).then((res) => {
            return res.status;
        });
    }
}
